import { estimateConfig } from '../data/estimateForm';
import type { EstimateFormValues } from '../types/estimate';

type SubmissionResult = { ok: true } | { ok: false; message?: string };

export async function submitEstimateRequest(values: EstimateFormValues): Promise<SubmissionResult> {
  try {
    const response = await fetch(`https://formsubmit.co/ajax/${estimateConfig.recipientEmail}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        _subject: `New Christmas Decoration Estimate Request — ${values.fullName.trim()}`,
        _template: 'table',
        _captcha: 'false',
        _honey: values.honey,
        _replyto: values.email.trim(),
        _autoresponse: estimateConfig.autoResponse,
        'Full Name': values.fullName.trim(),
        email: values.email.trim(),
        Phone: values.phone,
        'Property Address': values.address.trim(),
        'Property Type': values.propertyType,
        'Services Interested In': values.services.length ? values.services.join(', ') : 'Not specified',
        'Where to Install Decorations': values.installAreas.trim() || 'Not specified',
        'Additional Details': values.details.trim() || 'None',
        'Prefers to Be Present': values.preferPresent
          ? 'Yes — wants to be present. Contact customer to coordinate an afternoon visit.'
          : 'No — customer does not need to be present for measurement.',
        'Submitted From': window.location.href,
      }),
    });
    const data: { success?: boolean | string; message?: string } | null = await response.json().catch(() => null);
    const received = response.ok && (data?.success === true || data?.success === 'true');
    return received ? { ok: true } : { ok: false, message: data?.message };
  } catch {
    return { ok: false };
  }
}

export function formatPhone(value: string) {
  const digits = value.replace(/\D/g, '').slice(0, 10);
  if (digits.length < 4) return digits;
  if (digits.length < 7) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}
